const D = (c, a) => new Date(c).toLocaleString(`${a}`, {
  month: "long",
  day: "numeric",
  year: "numeric"
}), m = (c) => {
  var d;
  const a = [], { aboutAmwayNews: e, amwayNewsByYear: n, callBack: u, year: s } = c;
  e == null || e.forEach((r) => {
    a.push({ title: r.year, id: r.year });
  });
  const i = [];
  n == null || n.forEach((r) => {
    const { image: l, source: h, display_title: p, published_date: g, locale: f, link: t } = r, x = {
      url: l.url,
      source: h,
      description: p,
      publishedDate: D(g, f),
      link: {
        text: t == null ? void 0 : t.text,
        url: t == null ? void 0 : t.url,
        cta: t == null ? void 0 : t.cta,
        target: t == null ? void 0 : t.target
      }
    };
    i.push(x);
  });
  const o = e == null ? void 0 : e.find((r) => r.year.toString() === s.toString());
  return {
    componentType: "news_timelines",
    tabsData: a,
    heading: (d = o == null ? void 0 : o.header) == null ? void 0 : d.text,
    callBack: u,
    currentYearData: i,
    year: s
  };
};
export {
  m as default
};
//# sourceMappingURL=news-timelines-transformer.js.map
